// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".buyOptionsContent-tabs-tOr {\n    margin-bottom: 1.75rem;\n    display: flex;\n    justify-content: space-around;\n    gap: 1rem;\n    padding-bottom: 1.75rem;\n    border-bottom: 1px solid var(--venia-global-color-worldly-gray);\n}\n\n.buyOptionsContent-tabs-tOr h5 {\n    font-size: var(--venia-global-fontSize-base);\n    cursor: pointer;\n    padding-bottom: 0.7px;\n    border-bottom: 1px solid transparent;\n}\n\n.buyOptionsContent-tabs-tOr h5.buyOptionsContent-active-e2B {\n    border-bottom: 1px solid var(--venia-global-color-red);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": "buyOptionsContent-tabs-tOr",
	"active": "buyOptionsContent-active-e2B"
};
export default ___CSS_LOADER_EXPORT___;
